const InfoFilled = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'>
    <path
      fill='#06F'
      d='M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 1 0 0-16.666m.625 12.083a.625.625 0 0 1-1.25 0V9.94a.625.625 0 0 1 1.25 0zm-.608-5.833a.837.837 0 0 1-.838-.834c0-.46.37-.833.83-.833h.008a.833.833 0 1 1 0 1.667'
    />
  </svg>
);

export default InfoFilled;
